import { PROGRESS_START, PROGRESS_FINISH } from '../../mutation-types';
import profileApi from '../../../api/profile';
import provinceApi from '../../../api/province';

const defaultState = () => ({
	profile: {},
	optionBank: [],
	province: [],
	city: [],
	subdistrict: [],
	errors: {},
	errorsProfile: {},
	errorValid: {
		data: {},
		message: ''
	},
	bank: {},
	scedule: {},
	jam: [
	"00:00",
	"00:30",
	"01:00",
	"01:30",
	"02:00",
	"02:30",
	"03:00",
	"03:30",
	"04:00",
	"04:30",
	"05:00",
	"05:30",
	"06:00",
	"06:30",
	"07:00",
	"07:30",
	"08:00",
	"08:30",
	"09:00",
	"09:30",
	"10:00",
	"10:30",
	"11:00",
	"11:30",
	"12:00",
	"12:30",
	"13:00",
	"13:30",
	"14:00",
	"14:30",
	"15:00",
	"15:30",
	"16:00",
	"16:30",
	"17:00",
	"17:30",
	"18:00",
	"18:30",
	"19:00",
	"19:30",
	"20:00",
	"20:30",
	"21:00",
	"21:30",
	"22:00",
	"22:30",
	"23:00",
	"23:30"
	]
});

const state = defaultState();

const getters = {};

const mutations = {
	reset(state) {
		Object.assign(state, defaultState());
	},
	listProfile(state, data) {
		state.profile = Object.assign({}, state.profile, data);
	},
	listProvince(state, data) {
		state.province = []
		state.province = Object.assign({}, state.province, data);
	},
	listCity(state, data) {
		state.city = []
		state.city = Object.assign({}, state.city, data);
	},
	listSubdistrict(state, data) {
		state.subdistrict = []
		state.subdistrict = Object.assign({}, state.subdistrict, data);
	},
	responError(state, data) {
		state.errors = {}
		state.errors = Object.assign({}, state.errors, data)
	},
	responErrorProfile(state, data) {
		state.errorsProfile = {}
		state.errorsProfile = Object.assign({}, state.errorsProfile, data)
	},
	responErrorValid(state, data) {
		if (data !== 'Berhasil') {
			state.errorValid = {}
			state.errorValid = Object.assign({}, state.errorValid, data)
		} else {
			state.errorValid.message = data
		}
	},
	listBank(state, data) {
		state.bank = {}
		state.bank = Object.assign({}, state.bank, data)
	},
	setOptionBank(state, data) {
		state.optionBank = data.results
	},
	listScedule(state, data) {
		state.scedule = {}
		state.scedule = Object.assign({}, state.scedule, data)
	},
	listJam(state, data) {
		state.jam = {}
		state.jam = Object.assign({}, state.jam, data)
	},
};
const actions = {
	getProfile({ commit }) {
		commit(PROGRESS_START, null, { root: true });
		profileApi.getDataProfile().then(({ data: { data } }) => {
			commit('listProfile', data);
			commit(PROGRESS_FINISH, null, { root: true });
		});
	},
	getProvince({ commit }) {
		provinceApi.getProvince().then(({ data: { data: { results } } }) => {
			commit('listProvince', results);
		})
	},
	getCity({ commit }, value) {
		provinceApi.getCity({ province_id: value }).then(({ data: { data: { results } } }) => {
			commit('listCity', results);
		})
	},
	getSubdistrict({ commit }, value) {
		provinceApi.getDistrict({ city_id: value }).then(({ data: { data: { results } } }) => {
			commit('listSubdistrict', results);
		})
	},
	submit({ commit, dispatch }, params) {
		profileApi.updateAlamat(params).then(() => {
			dispatch('getProfile');
		}).catch((err) => {
			const data = err.response.data.data;
			commit('responError', data)
		})
	},
	submitProfile({ commit, dispatch }, params) {
		profileApi.udateProfile(params).then(() => {
			dispatch('getProfile');
		}).catch((err) => {
			const data = err.response.data.data;
			commit('responErrorProfile', data)
		})
	},
	getOptionBank({ commit }) {
		profileApi.getOptionBank().then(({ data: { data } }) => {
			commit('setOptionBank', data);
		})
	},
	submitBank({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			profileApi.submitBank(params).then(() => {
				dispatch('getBank');
				resolve()
			}).catch((err) => {
				const data = err.response.data.data;
				commit('responErrorProfile', data)
				reject()
			})
		})
	},
	submitToko({ commit, dispatch }, params) {
		profileApi.tutupToko(params).then((res) => {
			const sukses = res.data.message;
			commit('responErrorValid', sukses)
			dispatch('getProfile');
		}).catch((err) => {
			const error = err.response.data;
			commit('responErrorValid', error)
		})
	},
	bukaToko({ dispatch }) {
		profileApi.bukaToko().then(() => {
			dispatch('getProfile');
		})
	},
	uploadImage({ dispatch }, params) {
		profileApi.uploadImage(params).then(() => {
			dispatch('getProfile');
		})
	},
	getBank({ commit }) {
		return new Promise((resolve) => {
			profileApi.getDataBank().then(({ data: { data } }) => {
				commit('listBank', data);
				resolve()
			})
		})
	},
	getScedule({ commit }) {
		profileApi.getScedule().then(({ data: { data } }) => {
			commit('listScedule', data);
		})
	},
	updateScedule({ dispatch }, params) {
		profileApi.updateSchedule(params).then(() => {
			dispatch('getScedule');
		})
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}